import React, {Component} from 'react'
import './PopUp.css'

//REACT REDUX
import Dialog from "react-toolbox/lib/dialog/Dialog"

export default class PopUp extends Component {

    render() {
        let actions = [{label: "Close", onClick: this.props.handlePopUp}];

        return (
            <Dialog
                actions={actions}
                active={this.props.active}
                onEscKeyDown={this.props.handlePopUp}
                onOverlayClick={this.props.handlePopUp}
                title={this.props.title}>
                <p>{this.props.popUpMSG}</p>
            </Dialog>
        )
    }
};



// WEBPACK FOOTER //
// ./src/components/DashBoard/PopUpNotification/PopUp.js